class DatosClimaAeroMensual {
    constructor(
        titulo,
        subtitulo,
        totalObs,
        titulosCols,
        titulosCols2,
        porMesHora
    ) {
        this.titulo = titulo;
        this.subtitulo = subtitulo;
        this.totalObs = totalObs;
        this.titulosColumnas = titulosCols;
        this.titulosColumnas2 = titulosCols2;
        this.datosTabla = [];
        this.porMesHora = porMesHora;
    }

    addTabla(tabla) {
        this.datosTabla.push(tabla);
    }
}

export default DatosClimaAeroMensual;
